export default "__VITE_ASSET__BQseNU0v__"